import * as React from 'react'
import styled from 'styled-components'
import { useSize } from 'ahooks'
import classNames from '../_util/classNames'

const Wrapper = styled.div`
  position: relative;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
  .tab {
    position: relative;
    z-index: 1;
  }
  li {
    list-style: none;
    padding: 0 24px;
    height: 40px;
    white-space: nowrap;
    font-size: 16px;
    font-weight: 700;
    line-height: 40px;
    user-select: none;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    &.active {
      color: #000;
    }
    &.default {
      color: rgba(255, 255, 255, 0.65);
    }
  }
  .bar {
    position: absolute;
    bottom: 0;
    height: 40px;
    border-radius: 16px;
    background: #ffc9b1;
    transition: all 0.3s ease-in-out;
  }
`

interface TabsObjectType {
  key: string | number
  label: React.ReactNode
  children?: React.ReactNode
}

export interface TabsProps {
  className?: string
  items?: TabsObjectType[]
  activeKey?: number
  onChange?: (key: string | number, index: number, ele: any) => void
}

const Tabs: React.FC<TabsProps> = (props: TabsProps) => {
  const { className, items = [], onChange, activeKey } = props

  const tabsRef = React.useRef<HTMLUListElement>(null)

  // 根据size变化更新位置信息
  const innerSize = useSize(tabsRef)

  const [tabActive, setTabActive] = React.useState<number>(activeKey || 0)
  const [direction, setDirection] = React.useState<Array<{ width: number; left: number }>>([])

  const classes = classNames(className)

  // 更新条目位置信息
  const updateDirection = React.useCallback(() => {
    if (!tabsRef.current || items.length === 0) return
    const { left: spaceLeft } = tabsRef.current.getBoundingClientRect()
    const siteMap = Array.from(tabsRef.current.children).map((element) => {
      const { width, left } = element.getBoundingClientRect()
      return { width, left: left - spaceLeft }
    })
    setDirection(siteMap)
  }, [items.length])

  React.useEffect(() => {
    updateDirection()
  }, [updateDirection, innerSize])

  // 处理activeKey的变化
  React.useEffect(() => {
    if (activeKey !== undefined) {
      setTabActive(activeKey)
    }
  }, [activeKey])

  // 处理标签页的点击事件
  const handleChange = (key: string | number, index: number, ele: any) => {
    setTabActive(index)
    onChange?.(key, index, ele)
  }

  return (
    <Wrapper className={classes}>
      <ul className="tab row-start" ref={tabsRef}>
        {items.map((ele, index) => (
          <li
            className={tabActive === index ? 'active' : 'default'}
            key={ele.key}
            onClick={() => handleChange(ele.key, index, ele)}
            aria-hidden
          >
            {ele.label}
          </li>
        ))}
      </ul>
      {direction.length > 0 && <hr className="bar" style={direction[tabActive]} />}
    </Wrapper>
  )
}

export default Tabs
